import React from "react";
import { Redirect } from "react-router";
import { Query } from "react-apollo";

import authFetch from "./authFetch";
import client from "./apollo";
import queries from "./queries";

export class StartProcessOnClick extends React.Component {
    state = {
        nextTaskId: null,
    };

    startProcess = async (link, params) => {
        const body = JSON.stringify(params);
        const request = new Request(link, {
            method: "POST",
            body,
        });
        const response = await authFetch(request);
        const jsonRes = await response.json();
        this.setState({
            nextTaskId: jsonRes.next_task_id,
        });
    };

    handleClick = event => {
        event.preventDefault();
        this.startProcess(this.props.link, this.props.params);
    };

    renderRedirect = () => {
        const { nextTaskId } = this.state;
        return nextTaskId ? (
            <Redirect push to={`/tasks/${nextTaskId}/claim/`} />
        ) : null;
    };

    render() {
        return (
            <div onClick={this.handleClick}>
                {this.renderRedirect()}
                {this.props.component}
            </div>
        );
    }
}

export default class StartProcessHook extends React.Component {
    render() {
        return (
            <Query
                query={queries.HOOK}
                variables={{ hookType: this.props.hookType }}
                fetchPolicy="cache-and-network"
                client={client}
            >
                {({ loading, data }) => {
                    if (loading || !data || !data.clientConfig.hooks.length) {
                        return null;
                    }
                    return (
                        <StartProcessOnClick
                            link={data.clientConfig.hooks[0].link}
                            params={this.props.params}
                            component={this.props.component}
                        />
                    );
                }}
            </Query>
        );
    }
}
